export const LS_MODAL_ALLOW_LOCATION = 'flashChat_modalAllowLocation';
export const LS_MODAL_NOTIFICATION_PERMISSION = 'flashChat_modalNotificationPermission';
